import { Select } from 'antd'
import styled, { css } from 'styled-components'

const StyledLabelLegendsSelect = styled(Select)`
  width: 100%;

  .ant-select-selector {
    ${props =>
      props.isSuggestedByAi &&
      css`
        border-color: #1890ff !important;
      `};
    ${props =>
      props.isFromUnknownWords &&
      css`
        border-color: #ff0000 !important;
      `};
    ${props =>
      props.isChoice &&
      css`
        border-color: #044d02 !important;
      `};
  }
`

export default StyledLabelLegendsSelect
